var map = {
	"./": 72812,
	"./App": 54111,
	"./App.css": 44050,
	"./App.js": 54111,
	"./App.test": 26029,
	"./App.test.js": 26029,
	"./components/BgrdHomeTop/BgrdHomeTop": 27138,
	"./components/BgrdHomeTop/BgrdHomeTop.css": 49047,
	"./components/BgrdHomeTop/BgrdHomeTop.js": 27138,
	"./components/Breadcrumbs/Breadcrumbs": 11014,
	"./components/Breadcrumbs/Breadcrumbs.css": 27099,
	"./components/Breadcrumbs/Breadcrumbs.js": 11014,
	"./components/CartItems/CartItems": 98410,
	"./components/CartItems/CartItems.css": 75007,
	"./components/CartItems/CartItems.js": 98410,
	"./components/CatalogProduct/CatalogProduct": 46504,
	"./components/CatalogProduct/CatalogProduct.css": 62165,
	"./components/CatalogProduct/CatalogProduct.js": 46504,
	"./components/CatalogSort/Advantages": 85259,
	"./components/CatalogSort/Advantages.css": 84762,
	"./components/CatalogSort/Advantages.js": 85259,
	"./components/CatalogSort/CatalogNav": 60457,
	"./components/CatalogSort/CatalogNav.css": 48600,
	"./components/CatalogSort/CatalogNav.js": 60457,
	"./components/CatalogSort/CatalogSort": 84526,
	"./components/CatalogSort/CatalogSort.css": 31315,
	"./components/CatalogSort/CatalogSort.js": 84526,
	"./components/Footer/Footer": 6030,
	"./components/Footer/Footer.css": 48255,
	"./components/Footer/Footer.js": 6030,
	"./components/Footer/FooterSoc": 31787,
	"./components/Footer/FooterSoc.css": 17274,
	"./components/Footer/FooterSoc.js": 31787,
	"./components/FormCart/FormCart": 83352,
	"./components/FormCart/FormCart.css": 47713,
	"./components/FormCart/FormCart.js": 83352,
	"./components/Header/Header": 64036,
	"./components/Header/Header.css": 92627,
	"./components/Header/Header.js": 64036,
	"./components/Header/TopNav": 74139,
	"./components/Header/TopNav.css": 64624,
	"./components/Header/TopNav.js": 74139,
	"./components/Pagination/Pagination": 67540,
	"./components/Pagination/Pagination.css": 24225,
	"./components/Pagination/Pagination.js": 67540,
	"./components/Product/Product": 96574,
	"./components/Product/Product.css": 35859,
	"./components/Product/Product.js": 96574,
	"./components/PromoHome/PromoHome": 96034,
	"./components/PromoHome/PromoHome.css": 16831,
	"./components/PromoHome/PromoHome.js": 96034,
	"./components/Reviews/Reviews": 31182,
	"./components/Reviews/Reviews.css": 69531,
	"./components/Reviews/Reviews.js": 31182,
	"./components/Sales/Sales": 686,
	"./components/Sales/Sales.css": 60235,
	"./components/Sales/Sales.js": 686,
	"./components/ShippingAddress/ShippingAddress": 5902,
	"./components/ShippingAddress/ShippingAddress.css": 7795,
	"./components/ShippingAddress/ShippingAddress.js": 5902,
	"./components/SideBar/SideBar": 29626,
	"./components/SideBar/SideBar.css": 91447,
	"./components/SideBar/SideBar.js": 29626,
	"./components/SinglePageDescription/SinglePageDescription": 91974,
	"./components/SinglePageDescription/SinglePageDescription.css": 6123,
	"./components/SinglePageDescription/SinglePageDescription.js": 91974,
	"./components/SinglePageProduct/SinglePageProduct": 51926,
	"./components/SinglePageProduct/SinglePageProduct.css": 74283,
	"./components/SinglePageProduct/SinglePageProduct.js": 51926,
	"./components/SliderImg/SliderImg": 84382,
	"./components/SliderImg/SliderImg.css": 10707,
	"./components/SliderImg/SliderImg.js": 84382,
	"./data/catalogProducts": 58813,
	"./data/catalogProducts.json": 58813,
	"./data/products": 40554,
	"./data/products.json": 40554,
	"./data/singlePageProducts": 7317,
	"./data/singlePageProducts.json": 7317,
	"./img/advance_1_big.png": 61371,
	"./img/advance_2.png": 2151,
	"./img/advance_3.png": 49662,
	"./img/advance_4_big.png": 56650,
	"./img/card_1.png": 23282,
	"./img/card_2.png": 54249,
	"./img/card_3.png": 76128,
	"./img/card_4.png": 11103,
	"./img/card_5.png": 14166,
	"./img/card_6.png": 28141,
	"./img/card_7.png": 74244,
	"./img/card_8.png": 34467,
	"./img/crown.png": 28139,
	"./img/delivery.png": 95636,
	"./img/ellipse.png": 12192,
	"./img/forma_1_1113.png": 30640,
	"./img/forma_1_1673.svg": 63913,
	"./img/forma_1_1677.svg": 56901,
	"./img/google-plus.svg": 32006,
	"./img/layer_42_2490.png": 72936,
	"./img/like1.png": 1380,
	"./img/like2.png": 38239,
	"./img/like3.png": 41302,
	"./img/like4.png": 81385,
	"./img/line.png": 57038,
	"./img/line_2.png": 2273,
	"./img/linkedin.svg": 98606,
	"./img/logo.png": 62077,
	"./img/product1.png": 17526,
	"./img/product2.png": 47853,
	"./img/product3.png": 93956,
	"./img/product4.png": 57819,
	"./img/product5.png": 42994,
	"./img/product6.png": 57609,
	"./img/product7.png": 79488,
	"./img/product8.png": 80583,
	"./img/product9.png": 28094,
	"./img/rebox1.png": 64915,
	"./img/rebox2.png": 52952,
	"./img/rectangle_23_1802.png": 17733,
	"./img/rectangle_26_2879.png": 91525,
	"./img/rectangle_26_2905.png": 29569,
	"./img/rectangle_26_2920.png": 11542,
	"./img/sales.png": 89150,
	"./img/subscribe.jpg": 32078,
	"./img/top_background.png": 14080,
	"./img/truck.png": 63963,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./pages/Cart": 4533,
	"./pages/Cart.js": 4533,
	"./pages/Catalog": 51832,
	"./pages/Catalog.js": 51832,
	"./pages/Checkout": 80063,
	"./pages/Checkout.js": 80063,
	"./pages/Home": 89936,
	"./pages/Home.js": 89936,
	"./pages/SinglePage": 28640,
	"./pages/SinglePage.js": 28640,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./setupTests": 89472,
	"./setupTests.js": 89472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;